import { validateMany as validatePeople, buildContent as buildPersonContent } from '@/services/legal-ad-form/components/person';

export const validate = ownerList => {
  return validatePeople(ownerList, true);
};

export const buildContent = ownerList => {
  if (ownerList)
    return ownerList.map(owner => buildPersonContent(owner, 'Gérant'));
};